import { render } from "./Main.vue?vue&type=template&id=7dab9ef3"
const script = {}
script.render = render

export default script